<template>
  <footer class="shell-footer">
    <v-sheet
      class="overflow-hidden position-relative"
      color="secondary"
      max-width="100vw"
    >
      <v-container class="py-0">
        <div class="grid-list align-center">
          <div
            class="
              d-flex
              align-center
              justify-center justify-md-start
              py-6
              pr-10 pr-md-16
              mx-n3 mx-md-0
              grid-list-item grid-list-item-logotipo
            "
          >
            <router-link to="/">
              <img
                v-if="informations.img"
                class="d-block mx-auto mx-md-0 filter-white"
                :src="files + informations.img"
                height="80px"
              />
            </router-link>
          </div>

          <div class="d-flex flex-column align-start py-6 grid-list-item">
            <div
              class="
                white--text
                text-subtitle-1
                font-weight-bold
                text-uppercase
                mb-2
              "
            >
              Contato
            </div>

            <div
              v-for="(contact, keyContact) in footerContacts"
              :key="keyContact"
            >
              <div class="button-contact d-flex align-center">
                <div class="icon">
                  <v-icon
                    v-if="contact.icon"
                    :size="'24'"
                    class="mr-2"
                    color="white"
                  >
                    {{ contact.icon }}
                  </v-icon>
                  <v-img
                    class="mr-1"
                    v-else-if="contact.img"
                    :src="contact.img"
                  ></v-img>
                </div>
                <div>
                  <h5 class="py-0 my-0 white--text">{{ contact.title }}</h5>
                  <a
                    class="white--text text-decoration-none"
                    target="_blank"
                    :href="contact.link"
                  >
                    <div v-html="contact.text"></div>
                  </a>
                </div>
              </div>
            </div>

            <div class="d-flex justify-center justify-sm-end align-center mt-2">
              <div
                v-for="({ text, link, icon, size }, keySocial) in social"
                :key="keySocial"
                class="d-inline-flex"
                :class="{ 'ml-2': keySocial > 0 }"
              >
                <v-btn
                  :href="link"
                  target="_blank"
                  min-width="auto"
                  color="grey lighten-4"
                  small
                  :title="text"
                  depressed
                  rounded
                  fab
                >
                  <v-icon color="secondary" :size="size">{{ icon }}</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

          <div class="py-6 grid-list-item e-mec">
            <h3 class="text-center">
              Consulte aqui o cadastro da Instituição no Sistema e-Mec
            </h3>
            <img :src="require('@/assets/img/mec.jpg')" class="img-mec" />
          </div>
        </div>
      </v-container>
    </v-sheet>

    <v-sheet color="primary darken-2">
      <v-container
        class="
          pt-0
          pb-5
          d-flex
          flex-column flex-sm-row
          justify-space-between
          align-center
          text-center
        "
      >
        <div
          class="
            grey--text
            text--lighten-4 text-body-1
            font-weight-regular
            mt-5
          "
        >
          <b class="font-weight-bold"> {{ informations.name }}</b>
          © {{ year }}

          <span class="d-block d-sm-inline-block">
            Todos os direitos reservados.
          </span>
        </div>
        <a
          class="d-flex mt-5"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
// import { getContact } from "../../utils/getContact";
import { getIcon } from "../../utils/contactIcons";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
    footerContacts() {
      return this.$rest("contacts").list.map((item) => {
        return {
          title: item.title,
          text: item.text,
          link: item.link,
          icon: this.getIcon(item.icon.title),
          img: this.files + item.img + "?resize=1&w=24",
        };
      });
    },
  },
  methods: {
    getIcon,
  },
  created() {
    this.$rest("contacts").get();
  },
};
</script>

<style lang="scss" scoped>
.shell-footer {
  .grid-list {
    display: grid;
    gap: 24px 48px;
    grid-template-columns: auto 1fr auto;
    justify-content: space-between;

    @media screen and (min-width: 600.001px) and (max-width: 960px) {
      gap: 24px;
      grid-template-columns: auto auto;

      &-item:first-child {
        grid-column: 1 / -1;
      }
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 100%;
    }

    .grid-list-item-logotipo {
      position: relative;

      &:before {
        bottom: 0;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 50vw;
      }
    }

    .btn-contact::v-deep {
      .v-btn__content {
        max-width: 100%;
        white-space: normal;
        word-break: break-word;
      }
    }
  }
}

.e-mec {
  width: 200px;
  max-width: 100%;

  & img {
    max-width: 100%;
  }

  h3 {
    font-size: 16px;
    color: #fff;
    margin-bottom: 10px;
  }

  @media (max-width: 767px) {
    & {
      margin: auto;
    }
  }
}

.button-contact {
  margin: 10px 0;
  .icon {
    width: 32px;
    margin-right: 5px;
  }
}
</style>
